module.exports = {
  Types: ['get', 'post', 'put', 'delete']
}
